// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"61":"d0b704435a8a2213","78":"c501bf96ed9df007","84":"45299b066ad6fe8b","128":"2562dacec3ee2e23","218":"f181ed2f7425377e","560":"91a5ad8770531996","637":"2394d391a3680f21","793":"375223f475f1d3a8","927":"46aa59f83c0a9fc2"}[chunkId] + ".js";
};